import { Flex } from '@jisr-hr/design-system'
import classNames from 'classnames'
import DSIcon from 'components/DSIcon'
import { IconProps } from '@jisr-hr/ds'
import Styles from './WrappedIcon.module.css'

type WrappedIconProps = {
  background?: string
  borderColor?: string
  noBorder?: boolean
  backgroundSize?: 'small' | 'medium' | 'large'
  children?: JSX.Element
  iconContainerStyle?: string
  name?: string
  color?: string
}

const WrappedIcon = ({
  background,
  borderColor,
  children,
  name,
  iconContainerStyle,
  noBorder,
  backgroundSize,
  color,
  ...rest
}: WrappedIconProps & Omit<IconProps, 'name'>): JSX.Element => (
  <Flex
    justifyCenter
    itemsCenter
    className={classNames(
      Styles.iconContainer,
      iconContainerStyle,
      Styles[backgroundSize || 'large'],
    )}
    style={{ background, borderColor, ...(noBorder && { borderWidth: 0 }) }}
  >
    {name ? (
      <DSIcon
        {...rest}
        color={color}
        name={name}
      />
    ) : (
      children
    )}
  </Flex>
)

export default WrappedIcon
